import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Composer } from '../models/composer';
import { getApiUrl } from '../../main';

@Injectable({
  providedIn: 'root'
})
export class ComposerService {
  private apiUrl = getApiUrl() + '/composers';

  constructor(private http: HttpClient) {}

  getComposers(): Observable<Composer[]> {
    return this.http.get<Composer[]>(this.apiUrl);
  }

  updateComposer(id: number, composer: Composer): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/${id}`, composer);
  }

  deleteComposer(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  createComposer(composer: Composer): Observable<Composer> {
    return this.http.post<Composer>(this.apiUrl, composer);
  }
}